import { Assistance } from "./assistance";
import { Member } from "./member";
import { AssistancePlan } from "./assistance-plan";
import { Country } from "./country";
import { AssistancePayment } from './assistance-payment';

export const ASSISTANCE_SALE_STATUSES = {
  ACTIVE: 1,
  DELAYED: 2,
  CANCELED: 3,
  RENEWED: 4,
  ARREAR: 5,
  PENDING: 6
};

export const ASSISTANCE_SALE_STATUSES_TEXT = {
  1: 'Active',
  2: 'Delayed',
  3: 'Canceled',
  4: 'Renovado',
  5: 'Cliente en Mora',
  6: 'Pending Activation'
}

export const ASSISTANCE_SALE_STATUSES_OPERATION_SAC = {
  ACTIVE: 1,
  DELAYED: 2,
  CANCELED: 3,
  RET: 4,
  SO: 5,
  KIT: 6,
  CHANGE: 7,
};

export const ASSISTANCE_SALE_STATUSES_TEXT_OPERATION_SAC: any = {
  1: 'Active',
  2: 'Delayed',
  3: 'Canceled',
  4: 'Retencion',
  5: 'Modificación',
  6: 'Envio de Kit',
  7: 'Cambio de Plan'
};

export const ASSISTANCE_SALE_STATUSES_DEPENDENT = {
  ACTIVE: 1,
  INACTIVE: 0,
};

export const ASSISTANCE_SALE_STATUSES_TEXT_DEPENDENT: any = {
  1: 'Active',
  0: 'Inactive',
};

export class Assistancesale {
  id: number;
  member_id: number;
  member_name: string;
  address: string;
  salesman_id: number;
  payment_type: number;
  payment_gateway_id: number;
  payment_notes: string;
  code: string;
  referral_member_id: number;
  notes: string;
  token: string;
  last_4_digits: string;
  expiration_date: Date;
  issuer: number;
  payment_name: string;
  category: string;
  assistance_plan_id?: number;
  state_id: number;
  country_id: number;
  billing_cycle: number;
  is_new: boolean;
  countryId: number;
  product_id: number;
  assistanceplan: AssistancePlan;
  plan: AssistancePlan;
  product: Assistance;
  member: Member;
  status: number;
  date_canceled: Date;
  cancellation_reason: string;
  cancellation_comment: string;
  countries: Country[] = [];
  assistance_plan_name: string;
  plan_product_name: string;
  renewal_date: Date;
  authorization_code?: number;
  canceled_by: number;
  payments?: AssistancePayment[] = [];
  pending?: AssistancePayment[] = [];
  dependents = [];
  beneficiaries = [];

  country?: Country;
  date_effective?: any;
  date_issued?: any;
  pending_length?: any;

  free_assistance_period?: number;
  member_sale_classification?: number;

  collector_id?: number;

  sale_channel?: string;

  getStatusText(status: any) {
    if (status in ASSISTANCE_SALE_STATUSES_TEXT) {
      return ASSISTANCE_SALE_STATUSES_TEXT[status];
    }

    return '';
  }
}
